import React, { useEffect, useRef } from 'react'
import { Common } from '@trimblemaps/trimblemaps-js';
import { LOAD_MAP_PADDING, ZOOM_VALUE_17X } from '../../../utils/constants'
import { GeographicalService } from '../../../utils/common'
import './map.scss'
import "../../../components/shared/PCMilerMap/map.scss";
import { renderMapStopMarkerAndPopup } from './utils'
import { PCMilerSatelliteMapProps } from './PCMilerSatelliteMap.type'
import { LngLat } from './PCMiler.type'

export const PCMilerSatelliteMap = (props: PCMilerSatelliteMapProps) => {
    const {
        locationName,
        position,
    } = props;

    const MAP_CONTAINER_DOM = useRef<HTMLDivElement>(null);

    useEffect(() => {
        renderMap();
    }, []);

    async function renderMap() {
        const { lng: Lon, lat: Lat } = position;
        const latLng: LngLat = await GeographicalService.details.getLongitudeLatitude(Lon, Lat);
        const myMapBounds: TrimbleMaps.LngLatBounds = GeographicalService.details.createBounds(latLng, latLng);
        const myMapFitBoundsOptions: TrimbleMaps.FitBoundsOptions = { padding: LOAD_MAP_PADDING, maxZoom: ZOOM_VALUE_17X };
        const style: string = Common.Style.SATELLITE;
        const myMap: TrimbleMaps.Map = GeographicalService.details.renderMap(false,MAP_CONTAINER_DOM.current!, myMapBounds, style, myMapFitBoundsOptions);
        const myMapNavControl: TrimbleMaps.NavigationControl = GeographicalService.details.navControl({ showCompass: true });
        myMap.addControl(myMapNavControl, "bottom-right");
        myMap.on('load', function () {
            if(myMap.getLayer("labels_facility")) myMap.removeLayer("labels_facility");
            renderMapStopMarkerAndPopup(latLng, 1, 2, "D", locationName, myMap);
        });
    }

    return <div ref={MAP_CONTAINER_DOM} className="pc-miler-map"></div>
}